const EV_LIST_PAGE_SIZE = 27; // Items to show in EV list (archive-ev)

//Hamburger button
const h = document.querySelector(".hamburger"), m = document.querySelector(".nav-menu");
h && m && h.addEventListener("click", () => { 
	h.classList.toggle("is-active"); 
	m.classList.toggle("hidden-phone"); 
	// Automatically open the search input
	if (h.classList.contains("is-active")) {
		const searchContainer = document.getElementById('searchContainer');
		if (searchContainer) {
  			searchContainer.classList.add('expanded');
			  event.stopPropagation();
		}
	}
});


//Scroll fix
let lastScrollTop = 0;
const header = document.querySelector(".list-intro");
const getEVList = document.querySelector("#evlist");


let ticking = false;

function update() {
	let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (scrollTop > lastScrollTop) {
		let nextDiv = getEVList.getBoundingClientRect();
		// Scrolling down
		if(header.classList.contains("list-intro-pinned")) {
			if (nextDiv.top < 0) { // Only do the jump up once the actual cars about to roll by
				header.style.transform = "translateY(-100%)"; // Moves the header out of view
			}
		}
	} else {
		// Scrolling up
		header.style.transform = "translateY(0)"; // Moves the header back to its original position
	}

	lastScrollTop = scrollTop;
	ticking = false;
}

if (header && getEVList) {
	window.addEventListener("scroll", function() {
		if (!ticking) {
			window.requestAnimationFrame(update);
			ticking = true;
		}
	}, { passive: true });
}



// Search box
(function doSearch() {
	fetch( "/evdata.json" ); //Get the list of search pages
	const searchIconWrapper = document.getElementById('searchIconWrapper');
	const searchInput = document.getElementById('autoComplete');
	const searchContainer = document.getElementById('searchContainer');

	searchIconWrapper.addEventListener('click', function(event) {
		searchInput.value = '';
		event.stopPropagation();
		searchContainer.classList.toggle('expanded');
		if (searchContainer.classList.contains('expanded')) {
			searchInput.focus();
		}
	});

	document.addEventListener('click', function(event) {
		if (event.target !== searchIconWrapper && event.target !== searchInput) {
			//searchContainer.classList.remove('expanded');
		}
	});
})();

//https://tarekraafat.github.io/autoComplete.js/#/
// See evmodel plugin for criteria of whats in the search box.
const autoCompleteJS = new autoComplete({
  data: {
	src: async function() {
	  try {
		// Loading placeholder text
		document.getElementById("autoComplete").setAttribute("placeholder", "Loading...");
		// Fetch External Data Source
		const source = await fetch( "/evdata.json" );
		const data = await source.json();
		// Post Loading placeholder text
		document.getElementById("autoComplete").setAttribute("placeholder", "make, model...");
		// Returns Fetched data
		//console.log(data);
		return data;
	  } catch (error) {
		return error;
	  }
	},
	keys: ["title"],
},
resultsList: {
	maxResults: 10
},
cache: true,
submit:true,
resultItem: {
	element: (item, data) => {
	  item.style = "";
	  item.innerHTML = `
	  <span style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
		${data.match}
	  </span>`;
	},
	highlight: true
},
events: {
	input: {
		  focus: () => {
			if (autoCompleteJS.input.value.length) autoCompleteJS.start();
		  }
	}
} 
}); 

autoCompleteJS.input.addEventListener("selection", function (event) {
  const selectedValue = event.detail.selection.value;
  autoCompleteJS.input.blur();

  // Update the input field with the selected value
//  autoCompleteJS.input.value = selectedValue[event.detail.selection.key];
  const selectedUrl = selectedValue.url;
  window.location.href = selectedUrl;

  // Log the selected URL to the console
  console.log(selectedUrl);
});


// https://github.com/hsnaydd/moveTo
/* You can make a link: <a href="#target" class="js-trigger">Move</a>
Then <h3 id="target">Target</h3> */
const scroller = new MoveTo();
var triggers = document.querySelectorAll('.js-trigger');

triggers.forEach(function(i){
	scroller.registerTrigger(i);
	//console.log ("Register trigger",i);
});

// Watch for the filter bar for the archive-evs to go sticky.
const el = document.querySelectorAll(".list-intro");
const observer = new IntersectionObserver( 
  ([e]) => e.target.classList.toggle("list-intro-pinned", e.intersectionRatio < 1),
  { threshold: [1] }
);

if (el) {
	el.forEach(function(element) {
	  observer.observe(element);
	});
}


// EV Model pages, highlight navbar
function navlinkhighlight() {
	const sections = document.querySelectorAll('.sectionlink');
	const navLinks = document.querySelectorAll('.evmodel-sticky .js-trigger');

	function changeLinkState() {
		let index = sections.length;
		let stickyOffset = 65;

		while(--index && window.scrollY + 50 + stickyOffset < sections[index].offsetTop) {}

		navLinks.forEach((link) => link.classList.remove('active'));
		navLinks[index].classList.add('active');
	}

	changeLinkState();
	window.addEventListener('scroll', changeLinkState);
}
let evModelPage = document.querySelector('.single-evmodel');
if (evModelPage) {
	navlinkhighlight();

	var hash = window.location.hash.substr(1); // Remove the '#' from the hash
	if (hash) {
		var radioButton = document.getElementById(hash);
		if (radioButton) {
			radioButton.checked = true;
		}
	}
}

// for _charts method ..  
//var _charts = _charts || [];
//_charts.push(doChartBob);
function FunctionList(functions) {
  this.functions = functions;
}

FunctionList.prototype.callAll = function () {
  this.functions.forEach(function (f) {
	if (typeof(f) === "function")
	  f()
  });
}

// Animates the footer logo - DEPRECATED
/*
function createObserver(boxElement) {
  const observer = new IntersectionObserver(entries => {
	// Loop over the entries
	entries.forEach(entry => {
	  // If the element is visible
	  if (entry.isIntersecting) {
		// Add the animation class
		entry.target.classList.add('animate-logo');
	  }
	});  
  });
  observer.observe(boxElement);
}

// Set things up for animating the footer
window.addEventListener("load", (event) => {
  const boxElement = document.querySelector('#outline');
  if (boxElement) {
	createObserver(boxElement);
  } else {
	console.warn("Element with ID 'outline' not found.");
  }
}, false);*/


/****************** Show Hide stuff - used in Tell Me More dropdowns ******************/
const show = (e) => {
	const getHeight = () => {
		e.style.display = 'block';
		const height = e.scrollHeight + 'px';
		e.style.display = '';
		return height;
	};
	const height = getHeight(); //get natural height
	e.classList.add('is-visible'); //make element visible
	e.style.height = height; //update max-height

	//once the transition is complete, remove inline max-height so the content can scale responsively
	window.setTimeout(() => {
		//e.style.height = '';
	}, 350);
};

// hide element
const hide = (e) => {
	//give the element a height to change from
	e.style.height = e.scrollHeight + 'px';

	//set height back to 0
	window.setTimeout(() => {
		e.style.height = '1.4em';
	}, 1);
	window.setTimeout(() => {
		e.classList.remove('is-visible');
	}, 350);
}

const toggle = (e) => {
	if (e.classList.contains('is-visible')) {
		hide(e);
		return;
	}
	show(e);
};

var readmore = $readMoreJS({
   target: '.more-trigger',
  // wordsCount: 30, // Alternatively use `charactersCount` if you wish to truncate by characters' length.
  // charactersCount: 200,
   wordsCount: 35,
   toggle: false,
   moreLink: 'more...',
   lessLink: 'Read less',
   linkClass: 'rm-link-classname'
});

// btn switcher -- for Monthly Yearly graphs
var btns=document.querySelectorAll(".btn-switcher");

for(i=0;i<btns.length;i++){
  var btn=btns[i];
  btn.addEventListener("click",(function(){
	for(sibs=getSiblings(this),s=sibs.length;s--;)
	  removeClass(sibs[s],"selected");
	  addClass(this,"selected")
  }))
}

/*********** Modals ****************/
function doModal(target) {
	const callbacks = {
	plateCallback: function() {
			plateCallback();
		}
	};
	console.log("Target: ", target);

	//var content = document.getElementById(target.dataset.target).innerHTML;
	var callbackName = target.dataset.callback;
	window.onlymodal = new tingle.modal({
		onClose: function() {
			window.onlymodal.destroy();
		},
	});
	
	var element = document.getElementById(target.dataset.target);
	if (element) {
		//content = element.innerHTML; 
		var div = document.createElement("div"); 
		for (let i = 0; i < element.children.length; i++) {
			const clone = element.children[i].cloneNode(true);
			
			if (clone.id.length > 0) {
				clone.id = element.id + "_" + clone.id
			}
			div.appendChild(clone);
		}
		content = div; 
	} else {
		content = "Missing";
		console.log ("missing target: ", target.dataset.target, "clicked: ", target);
	}
	window.onlymodal.setContent(content);
	window.onlymodal.open();
	
	if (callbackName && typeof callbacks[callbackName] === "function") {
		callbacks[callbackName]();
	}
}

function replaceTemplateText (content, re, vars) {
	var placeholders = content.match(re);
	
	if (placeholders) {
		placeholders.forEach(function(placeholder) {
			var phText = placeholder.substring(1, placeholder.length - 1);
	
			if (vars[phText]) {
				content = content.replace(placeholder, vars[phText])
			}
		})
	}
	return content;
}

// doSingle & specObj - called on top cheapest pages
function doCompareModal(doSingle=false,specObj={},isUsed=false) {
	// Get rid of existing modal of this kind
	if (window.comparemodal) {
		window.comparemodal.destroy();
	}
	window.comparemodal = new tingle.modal({ });
	
	var content = document.getElementById("compare-modal").innerHTML;
	
	//console.log (doSingle);
	
	if (doSingle) {
		content = document.getElementById("single-spec-modal").innerHTML;
		let re = new RegExp('\{([a-z]+)\}', 'g');
		content  = replaceTemplateText(content,re,specObj);
		var dom = document.createElement('div');
		dom.style.maxWidth = "400px"; 
		dom.innerHTML = content;
		window.comparemodal.setContent(dom);
		window.comparemodal.open();
		return;
	}
	
	// If i need to sort https://stackoverflow.com/questions/62144425/adding-localstorage-items-in-the-order-it-was-added
	// this loads the table template with all the data.  MAKE SURE the template items match the key  of the JSON items
	/******* THIS CODE IS DEPRECATED ***/
	/*
	let keycount = 0;
	for (var i = 0; i < window.sessionStorage.length; i++) {
		if (window.sessionStorage.key(i).startsWith("veh")) {
			let vars = JSON.parse(window.sessionStorage.getItem(window.sessionStorage.key(i)));
			let re = new RegExp('\{([a-z]+)\}', 'g');
			if (keycount > 0) {
				re = new RegExp('\{([a-z]+' + '\-' + keycount + ')\}', 'g');
				Object.keys(vars).forEach((key)=>{ //this will return array of keys
				 newKey = key + "-" + keycount;
				   vars[newKey] = vars[key] ; //saving reference in your new key.
				   delete vars[key]; //deleting old key;
				});
			}
			
			content  = replaceTemplateText(content,re,vars);
			keycount++;
		}
	}*/
	
	/* New method */
	// Features array – each object contains the label (first column), the key name (second column)
	// and an optional dataAttr to add to the row (e.g. "min", "max", "max-mm").
	const features = [
		isUsed 
		? { key: "usedprice", label: "Used Price Est.", dataAttr: "min" }
		: { key: "price", label: "Price", dataAttr: "min" },
	 // { key: "usedprice",   label: "Used Price Est.", dataAttr: "min" },
	 // { key: "price",       label: "Price",           dataAttr: "min" },
	  { key: "range",       label: "Range (WLTP)",    dataAttr: "max" },
	  { key: "rangeh",      label: "Range (highway)", dataAttr: "max" },
	  { key: "rangep",      label: "$ / km range",  dataAttr: "min" },
	  { key: "battery",     label: "Battery (nominal)" },
	  { key: "usable",      label: "Battery (usable)" },
	  { key: "chem",        label: "Chemistry" },
	  { key: "efficiency",  label: "Efficiency",      dataAttr: "min" },
	  { key: "shape",       label: "Shape" },
	  { key: "drivetrain",  label: "Drivetrain" },
	  { key: "power",       label: "Power",           dataAttr: "max" },
	  { key: "acceleration",label: "0-100 km/h",      dataAttr: "min" },
	  { key: "topspeed",    label: "Top Speed" },
	  { key: "charger",     label: "AC Charge",       dataAttr: "max" },
	  { key: "dccharger",   label: "Fast Charge",     dataAttr: "max" },
	  { key: "vtol",        label: "V2L",            dataAttr: "max" },
	  { key: "towb",        label: "Tow (braked)",    dataAttr: "max" },
	  { key: "towu",        label: "Tow (unbraked)",  dataAttr: "max" },
	  { key: "lengthmm",    label: "Length ↔",        dataAttr: "max-mm" },
	  { key: "width",       label: "Width ↔",         dataAttr: "max-mm" },
	  { key: "height",      label: "Height ↕",        dataAttr: "max-mm" },
	  { key: "ground",      label: "Ground clearance"},
	  { key: "weight",      label: "Weight",          dataAttr: "min" },
	  { key: "boot",        label: "Boot Space",      dataAttr: "max-mm" },
	  { key: "bootall",     label: "Boot Max",        dataAttr: "max-mm" },
	  { key: "frunk",       label: "Frunk",           dataAttr: "max-mm" }
	];
	
	// Build the EVs array from sessionStorage
	// Collect keys from sessionStorage that start with "veh"
	const vehKeys = [];
	for (let i = 0; i < window.sessionStorage.length; i++) {
	  const key = window.sessionStorage.key(i);
	  if (key.startsWith("veh")) {
		vehKeys.push(key);
	  }
	}
	
	// Sort keys by the numeric part after "veh"
	vehKeys.sort((a, b) => {
	  const numA = parseInt(a.substring(3), 10);
	  const numB = parseInt(b.substring(3), 10);
	  return numA - numB;
	});
	
	// Build the EVs array using the sorted keys
	const EVs = vehKeys.map(key => JSON.parse(window.sessionStorage.getItem(key)));

	// Function to build the compare table dynamically.
	function buildCompareTable(EVs, features) {
	  let html = '<table class="comparetable"><thead style="position: sticky; top: -8vh; background-color: #f9fafb; box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.1);"><tr><th></th>';
	
	  // Build header row: first column is empty, then each EV title.
	  EVs.forEach(ev => {
		html += `<th>${ev.title}</th>`;
	  });
	  html += '</tr></thead><tbody>';
	
	  // Build rows for each feature.
	  features.forEach(feature => {
		// If a data attribute is specified, add it to the <tr> tag.
		const dataAttribute = feature.dataAttr ? ` data-${feature.dataAttr}` : "";
		html += `<tr${dataAttribute}><td>${feature.label}</td>`;
		EVs.forEach(ev => {
		  html += `<td>${ev[feature.key] || 'N/A'}</td>`;
		});
		html += '</tr>';
	  });
	
	  html += '</tbody></table>';
	  return html;
	}
	
	content = buildCompareTable(EVs, features); // Create the table

	var dom = document.createElement('div');
	dom.innerHTML = content;
	// Create a button element
	var buttonWrapper = document.createElement('div');
	buttonWrapper.className = 'text-center'; // Assuming you have a class for centering
	
	var button = document.createElement('button');
	button.textContent = 'Close';  // Set button text
	button.className = 'btn btn-blue btn-large'; 
	button.style.marginTop = '2rem';
	button.addEventListener('click', function() {
		window.comparemodal.close(); // Assuming 'modal' is the Tingle.js modal instance
	});

	buttonWrapper.appendChild(button);
	dom.appendChild(buttonWrapper);
	
	// Now we have a dom element, try to find the mins and max.
	for (var i = 0, row; row = dom.firstElementChild.rows[i]; i++) {
		cols = row.cells.length;
		if (cols == 2){
			continue;
		}
		min = Number.MAX_VALUE;
		max = Number.MIN_VALUE;
		let min_i = 0;
		let max_i = 0;
		//console.log (cols);
		for (let i = 1; i < cols; i++) {
			const regex = /\$|,/g;
			val = parseFloat(row.cells[i].innerText.replace(regex, ''));
			//console.log (val)
			if (isNaN(val)) {
				continue;
			}
			if (val > max) {
				max = val;
				max_i = i;
				//continue;
			}
			if (val < min) {
				min = val;
				min_i = i;
			}
		}
		
		min_c = row.cells[min_i];
		max_c = row.cells[max_i];
		if (row.hasAttribute('data-min') && min_i > 0) {
			let last = min_c.innerText;
			min_c.innerHTML = `<span class="spec-min">${min_c.innerHTML}</span>`;
			while (min_i < 3) {
			  if (row.cells[min_i].innerText == last) {row.cells[min_i].innerHTML = `<span class="spec-min">${last}</span>`;}
			  min_i++;
			}
		}
		if (row.hasAttribute('data-max')  && max_i > 0) {
			
			let last = max_c.innerText;
			max_c.innerHTML = `<span class="spec-max">${max_c.innerHTML}</span>`;
			while (max_i < 3) {
			  if (row.cells[max_i].innerText == last) {row.cells[max_i].innerHTML = `<span class="spec-max">${last}</span>`;}
			  max_i++;
			}
		}
		if (row.hasAttribute('data-max-mm')  && max_i > 0) {
			let last = max_c.innerText;
			max_c.innerHTML = `<span class="spec-max-mm">${max_c.innerHTML}</span>`;
			while (max_i < 3) {
			  if (row.cells[max_i].innerText == last) {row.cells[max_i].innerHTML = `<span class="spec-max-mm">${last}</span>`;}
			  max_i++;
			}
		}
	}
	
	window.comparemodal.setContent(dom);
	window.comparemodal.open();
}

// Called on evmodel - calculates running cost
function doCalcModal(target) {
	// Get rid of existing modal of this kind
	if (window.costmodal) {
		window.costmodal.destroy();
	}
	
	window.costmodal = new tingle.modal({
	});
	
	var unitPrice = 30;
	var kwh = 0;
	
	// Retrieve from local storage
	if (localStorage.getItem("dollarIDNew")) {
		const savedData = JSON.parse(localStorage.getItem("dollarIDNew")); 
		unitPrice = savedData["dollarIDNew"];
	}
	
	if (target.dataset.wh.length > 0 ) {
		kwh = (target.dataset.wh * 100) / 1000;
		
		var cost = (unitPrice / 100) * kwh;
		rounder = Math.round((cost) * 100) / 100;
		var formatter = new Intl.NumberFormat('en-NZ', { style: 'currency', currency: 'NZD', });
		dollar = formatter.format(cost); 
	} else {
		return;
	}
	
	// Get the modal (already hidden) and put our strings into the template
	var content = document.querySelector('.modal-efficiency').innerHTML;
	// Replaces {placeholder} with var https://mightytechno.com/replace-placeholders-in-javascript/
	var vars = { "wh":target.dataset.wh,"kwh":kwh,"centsRange":"centsRangeNew","dollarID":"dollarIDNew","dollar":dollar,"model":target.dataset.model,"unitPrice":unitPrice,"defaultPrice":target.dataset.defaultprice};
	
	var re = /\{(.*?)\}/g;
	content  = replaceTemplateText(content,re,vars);
	
	// This code takes the string and converts to a HTMLDocument. Unfortunately frags dont receive events.
	const parser = new DOMParser();
	frag = parser.parseFromString(content, 'text/html');

	// Convert into a nodelist and roll up into a single div
	nodes = frag.body.childNodes;
	var newNode = document.createElement("div");
	for (var i = 0; i < nodes.length; i++) {
		newNode.appendChild(nodes[i]);
	}

	window.costmodal.setContent(newNode);
	window.costmodal.open();

	// Only now can we capture the event !!
	var e = document.getElementById("centsRangeNew");
	e.addEventListener("input", (event) => {
		var dollarID = document.getElementById("dollarIDNew");
		var cost = (event.target.value / 100) * kwh, dollar =  "$" + cost.toFixed(2);
		dollarID.innerHTML = dollar;
		let data = {};
		data["dollarIDNew"] = event.target.value;
		localStorage.setItem("dollarIDNew", JSON.stringify(data));
	});
}

// Called on single-evmodel, estimated driving economy
function doEconomyModal(target) {
	// Get rid of existing modal of this kind
	if (window.economymodal) {
		window.economymodal.destroy();
	}

	window.economymodal = new tingle.modal({}
	);
	
	var kwh = 0;

	if (target.dataset.wh.length > 0) {
		kwh = (target.dataset.wh * 100) / 1000;
		//kms = Math.round((100 / kwh) * 10) / 10;
		kms = target.dataset.km;
		var vars = { "wh":target.dataset.wh,"kwh":kwh,"km":kms,"model":target.dataset.model};
		
		// Get the modal (already hidden) and put our strings into the template
		var content = document.querySelector('#driving-economy').innerHTML;
		var re = /\{(.*?)\}/g;
		content = replaceTemplateText(content, re, vars)
		window.economymodal.setContent(content);
		window.economymodal.open();

	} else {
		return;
	}
}/******** E N D   O F   M O D A L S *******/

//listen for click event across the document
document.addEventListener('click', event => {
	const target = event.target;
	if (target.classList.contains('dropbox')) {
		const content = target.firstChild;
		if (content) toggle(content);
	} else if (target.classList.contains('pageall')) {
		const obj = target.dataset.target;
		return Function(`"use strict";return pageAll(${obj})`)(); // Like Eval
	} else if (target.classList.contains('clickable-modal') || target.classList.contains('clickable-query') || target.classList.contains('clickable')) {
		const id = target.dataset.id;
		if (id === "economy") {
			doEconomyModal(target);
		} else if (id === "wh") {
			doCalcModal(target);
		} else {
			doModal(target);
		}
	} else if (target.classList.contains('compare-add')) {
		addtoCompare(target);
		return;
	} else if (target.classList.contains('single-compare')) {
		const c = target.closest("LI");
		const obj = JSON.parse(c.dataset.json);
		obj.title = c.querySelector("h3").innerHTML;
		doCompareModal(true, obj);
	} else {
		return;
	}
	event.preventDefault();
}, false);

// Special event for top cheapest and quickest, otherwise existing code gets stuck on the wrong target for the click
const cardLinks = document.querySelectorAll('.top-compare');
  cardLinks.forEach(function(cardLink) {
	cardLink.addEventListener('click', function(event) {
	const target = event.target;
	  event.stopPropagation();
	  const c = target.closest("LI");
	  const obj = JSON.parse(c.dataset.json);
	  obj.title = c.querySelector("h3").innerHTML;
	  doCompareModal(true, obj);
	});
  });


function showCompareNew() {
	// clear sessionstorage
	isUsed = false;
	let container = document.querySelector("#evlist");
	if (container) {
		container.querySelectorAll('.compare-add').forEach(function(checkbox) {
		  checkbox.checked = false;
		});
	}
	container = document.querySelector("#evlist3"); //Used
	if (container) {
		isUsed = true;
		container.querySelectorAll('.compare-add').forEach(function(checkbox) {
		  checkbox.checked = false;
		});
	}
	// Find and remove the toast when clicked
	const toastElements = document.querySelectorAll(".toastify");
	toastElements.forEach(toast => toast.remove());
	doCompareModal(false,null,isUsed);
	window.sessionStorage.clear();
}

// Add items to sessionstorage on archive-ev page https://blog.logrocket.com/localstorage-javascript-complete-guide/
function addtoCompare(e) {
	//console.log (e);
	checkState = false;
	if (e.tagName === "LABEL") {
		checkbox = e.firstChild;
		checkbox.checked = !checkbox.checked;
		checkState = checkbox.checked;
	} else {
		checkState = e.checked;
	}
	
	let c = e.closest("li");
	const modelsAllowed = 5;
	
	if (checkState) {
		const obj = JSON.parse(c.dataset.json);
		obj.title = c .querySelector("h3").innerHTML; // Add the title to the object
		const newObj = JSON.stringify(obj)

		window.sessionStorage.setItem(c.id,newObj);
		
		let keycount = 0;
		for (var i = 0; i < window.sessionStorage.length; i++) {
		  if (window.sessionStorage.key(i).startsWith("veh")) {
			  keycount++;
		  }
		}
		
		if (keycount == 1) {
			//https://github.com/apvarun/toastify-js
			let num = (modelsAllowed-keycount == 1 ? 'one' : 'two');
			str = '<div><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 20 20" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M6.672 1.911a1 1 0 10-1.932.518l.259.966a1 1 0 001.932-.518l-.26-.966zM2.429 4.74a1 1 0 10-.517 1.932l.966.259a1 1 0 00.517-1.932l-.966-.26zm8.814-.569a1 1 0 00-1.415-1.414l-.707.707a1 1 0 101.415 1.415l.707-.708zm-7.071 7.072l.707-.707A1 1 0 003.465 9.12l-.708.707a1 1 0 001.415 1.415zm3.2-5.171a1 1 0 00-1.3 1.3l4 10a1 1 0 001.823.075l1.38-2.759 3.018 3.02a1 1 0 001.414-1.415l-3.019-3.02 2.76-1.379a1 1 0 00-.076-1.822l-10-4z" clip-rule="evenodd"></path></svg> COMPARE</div>';
			//str += "<div>"  + " Compare - <strong>choose " + num + " more</strong></div>";
			str +=  `
			<div class="toast-content">
			  <div class="toast-title">${obj.title}</div><div> <strong>Choose up to 5 vehicles</div></div>	 
			</div>
			`;
			Toastify({
			  text: str,
			  escapeMarkup: false,
			  //duration: 3500,
			  duration: -1,
			  //close: true,
			  gravity: "bottom",
			  position: "center",
		  	  onClick: function() {
				// Find and remove the toast when clicked
				const toastElement = document.querySelector(".toastify");
				if (toastElement) {
					showCompareNew();
				}
			  } 
			}).showToast();
		}
		
		if (keycount > 1) {
			//const toastElement = document.querySelector(".toastify");
			//toastElement.innerHTML = "Hello";
		}
		
		if (keycount === modelsAllowed) {
			showCompareNew();
			return;
		}

	} else {
		window.sessionStorage.removeItem(c.id);
		//const toastElements = document.querySelectorAll(".toastify");
		//toastElements.forEach(toast => toast.remove());
	}
	
	// Add the compare model names to the toast.
	let titles = [];
	const toastTitle = document.querySelector(".toast-title");
	const toastElement = document.querySelector(".toastify");
	  // Loop through sessionStorage keys and extract vehicle titles.
	var toastCount = 0;
	
	for (let i = 0; i < window.sessionStorage.length; i++) {
		const key = window.sessionStorage.key(i);
		if (key.startsWith("veh")) {
		toastCount++;
		const evData = JSON.parse(window.sessionStorage.getItem(key));
		titles.push(evData.title || "Untitled");
		}
	}
	
	// Update the toast element with the list of titles.
	toastTitle.textContent = titles.join(", ");
	if (toastCount == 0 ) { // Delete the toast if nothing left.	  
		if (toastElement) toastElement.remove();
	} 
	if (toastCount > 1 ) {
		// Add the shake animation
		if (toastElement) {
			toastElement.classList.remove("shake");
			
			// Use requestAnimationFrame to ensure a clean restart of the animation
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
			toastElement.classList.add("shake");
			});
		});
		}
	}
}

// Helpers
function hasClass(el, className) {
	    return el.classList ? el.classList.contains(className) : new RegExp('\\b'+ className+'\\b').test(el.className);
	}
	
function addClass(el, className) {
    if (el.classList) el.classList.add(className);
    else if (!hasClass(el, className)) el.className += ' ' + className;
}
	
function removeClass(el, className) {
    if (el.classList) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp('\\b'+ className+'\\b', 'g'), '');
}
var getSiblings = function ( elem ) {
    var siblings = [];
    var sibling = elem.parentNode.firstChild;
    for ( ; sibling; sibling = sibling.nextSibling ) {
        if ( sibling.nodeType === 1 && sibling !== elem ) {
            siblings.push( sibling );
        }
    }
    return siblings;
};

//Modal images
var allImg = document.querySelectorAll('.ev-image');

if (allImg.length > 0) {
  var modalCarImg = new tingle.modal({ cssClass: ['ev-image-modal'] });

  allImg.forEach(function (button) {
	button.addEventListener("click", (event) => {
	  modalCarImg.setContent(event.target.outerHTML);
	  modalCarImg.open();
	});
  });
}

function doSort() {
	//console.log ("sorted");
	setTimeout(function () {
			document.querySelector('.list').classList.toggle('fade');
		}, 1);
}

// Table sorting on archiveEV page.
if (document.querySelector('#evlist')) {
	// Clear sessionstorage (for compare)
	window.sessionStorage.clear();
	
	var options = {
		valueNames: [ 'name','range', 'price', 
		  { name: 'shape', attr: 'data-shape' },
		  { name: 'pph', attr: 'data-pph'} ,
		  { name: 'make', attr: 'data-make'} ,
		  { name: 'drive', attr: 'data-drive' },
		  { name: 'seats', attr: 'data-seats' },
		  { name: 'boot', attr: 'data-boot'} 
  		],
		  page: EV_LIST_PAGE_SIZE,
		  innerWindow: 1,
		  paginationClass: 'listpaginator',
		  pagination: true	 
	};
	
	// Future
	var options2 = {
		valueNames: [ 'name','when','range',
		 { name: 'shape', attr: 'data-shape' },
		 { name: 'make', attr: 'data-make'} 
		],
		page: EV_LIST_PAGE_SIZE,
	  innerWindow: 1,
	  
 	 pagination: true	 
	};
	
	var options3 = { //Used
		valueNames: [ 'name','range', 'price',
		  { name: 'shape', attr: 'data-shape' },
		  { name: 'make', attr: 'data-make'} 
		  ]
	};
	
	// Used by each select.
	function handleEVSort(e,el) {
		const options = Array.from(e.target.options); // Get array of options
		options.forEach(element => {element.innerText = element.innerText.replace('Sort: ', '')}); //Clear the Sort:
		
		options[el.selectedIndex].text = "Sort: " + options[el.selectedIndex].text; //Add Sort: to selected
		var sortOrder = e.target.value.toLowerCase().split('-'); //Extract the value
		return sortOrder
	}
	
	// Add Event handlers for sort - CHANGE the output on the cards to show special data
	var sortNew = document.getElementById("sortorderNew");
	if (sortNew) {
		sortNew.selectedIndex = 0; // for page refresh
		sortNew.addEventListener('change', function(e) {		
			sortOrder = handleEVSort(e,sortNew);
			evList.sort(sortOrder[0], { order: sortOrder[1] }); 
			
			if (sortOrder[0] === "boot") {
				for (i in evList.items) {
					tit = evList.items[i].elm.querySelector('.battery');
					let boot = evList.items[i].elm.querySelector('.boot').dataset.boot;
					unit = "L";
					if (boot == 0) {boot="-";unit="";}
					tit.childNodes[0].innerText = "MAX BOOT SPACE";
					tit.childNodes[1].nodeValue = boot;
					tit.childNodes[2].innerText = unit;
				}
			} else if (sortOrder[0] === 'pph') {
				for (i in evList.items) {
					tit = evList.items[i].elm.querySelector('.battery');
					let pph = evList.items[i].elm.querySelector('.pph').dataset.pph;
					tit.childNodes[0].innerText = "$ PER RANGE";
					tit.childNodes[1].nodeValue = '$' + pph;
					tit.childNodes[2].innerText = "";
				}
			} else {
				for (i in evList.items) {
					tit = evList.items[i].elm.querySelector('.battery');
					let bat = evList.items[i].elm.querySelector('.battery').dataset.battery;
					tit.childNodes[0].innerText = "BATTERY";
					tit.childNodes[1].nodeValue = bat;
					tit.childNodes[2].innerText = "kWh";
				}
			}
		})
	}
	
	var sortUsed = document.getElementById("sortorderUsed");
	if (sortUsed) {
		sortUsed.selectedIndex = 0; 
		sortUsed.addEventListener('change', function(e) {		
			sortOrder = handleEVSort(e,sortUsed);
			evList3.sort(sortOrder[0], { order: sortOrder[1] }); 
		})
	}
	
	var sortFuture = document.getElementById("sortorderFuture");
	if (sortFuture) {
		sortFuture.selectedIndex = 0; 
		sortFuture.addEventListener('change', function(e) {		
			sortOrder = handleEVSort(e,sortFuture);
			console.log(sortOrder);
			evList2.sort(sortOrder[0], { order: sortOrder[1] }); 
			evList2.show(0,EV_LIST_PAGE_SIZE);

		})
	}
	
	/*function filterMakes(e,list) {
		var make = e.target.value.toLowerCase();
		console.log (make, list);
		
		if (make == "all") {
			list.filter();
			removeClass(e.target.parentNode, "selected");
		} else {
			addClass(e.target.parentNode, "selected");
			
			list.filter(function(item) {
				//console.log (item.values());
				if (item.values().make == make) {
				   return true;
				} else {
				   return false;
				}
			}); 

		}
	}*/
	
	//Add options to make select
/*	var makeselect = document.getElementById('makeselect');
	if (makeselect && makes) {
		var arrayLength = makes.length;
		for (var i = 0; i < arrayLength; i++) {
			makeselect.options[makeselect.options.length] = new Option(makes[i]);
		}
		
		makeselect.addEventListener('change', function(e) {
			filterMakes(e,evList);
		});
	}
	
	var makeselect3 = document.getElementById('makeselect3');
	if (makeselect3 && makesUsed) {
		var arrayLength = makesUsed.length;
		for (var i = 0; i < arrayLength; i++) {
			makeselect3.options[makeselect3.options.length] = new Option(makesUsed[i]);
		}
		
		makeselect3.addEventListener('change', function(e) {
			filterMakes(e,evList3);
		});
	}*/
	const makeSelect = id => {
	  const select = document.getElementById(id);
	  if (!select) return;
	
	  const options = id === 'makeselectNew' ? makes: makes;
	  if (!options) return;
	
	  options.forEach(option => {
		select.options[select.options.length] = new Option(option);
	  });
	
	  select.addEventListener('change', e => {
		//filterMakes(e, id === 'makeselectNew' ? evList : (id === 'makeselectUsed' ? evList3 : evList2));
		filterNew(e, id === 'makeselectNew' ? evList : evList);
	  });
	};
	
	makeSelect('makeselectNew');

	
	// Establish the lists	
	var evList = new List('evlist', options);
	var evList2 = new List('evlist2', options2); // Future
	var evList3 = new List('evlist3', options3); //Used
	
	evList.on('updated', (e) => {
		const moveTo = new MoveTo();
		moveTo.move(document.getElementById("evlist"));
	});
	
	evList2.on('updated', (e) => {
		const moveTo = new MoveTo();
		moveTo.move(document.getElementById("evlist2"));
	});
	
	evList3.on('updated', (e) => {
		const moveTo = new MoveTo();
		moveTo.move(document.getElementById("evlist3"));
	});
	
	var rebate = document.getElementById('rebate');
	if (rebate) {
		rebate.addEventListener('click', function(e) {
			console.log (e.target);
			applyRebate(e.target.checked,evList);
		});	
	}
	
	function pageAll (obj) {
		obj.show(0,obj.size());
	}
	
	//Clear other selects
	function clearSelects(currentSelect) {
		// Get all select elements
		var allSelects = document.querySelectorAll('.select-clear'); // Add more selects here if needed
		
		allSelects.forEach(function(select) {
			if (select && select !== currentSelect) { // Check if the select exists and is not the current one
				select.selectedIndex = 0;
				removeClass(select.parentNode, "selected");
			}
		});
	}
	
	function getAllSelectedValues() {
		// This will hold all the selected values from different select boxes
		let criteria = {
			shape: document.querySelector('#shapeselect') ? document.querySelector('#shapeselect').value.toLowerCase() : null,
			make: document.querySelector('#makeselectNew') ? document.querySelector('#makeselectNew').value.toLowerCase() : null,
			drive: document.querySelector('#driveselect') ? document.querySelector('#driveselect').value.toLowerCase() : null,
			seats: document.querySelector('#seatselect') ? document.querySelector('#seatselect').value : null,
			// ... add other criteria as needed
		};
	
		return criteria;
	}
	function filterNew(e,list) {
		let criteria = getAllSelectedValues();
		let currentCriteria = e.target.name; // assuming the select box has a 'name' attribute that corresponds to its criteria type
	
		if (criteria[currentCriteria] === "all") {
			removeClass(e.target.parentNode, "selected");
		} else {
			addClass(e.target.parentNode, "selected");
		}

		// If nothing matches show the empty state
	//	list.on('filterComplete',data => {
			list.on('updated',data => {
			let nothingFoundElem = document.getElementById('nothing-found');
			
			if (nothingFoundElem) {
				if (list && list.visibleItems && list.visibleItems.length === 0) {
					nothingFoundElem.style.display = "block";
				} else {
					nothingFoundElem.style.display = "none";
				}
			} 
		});
		list.filter(function(item) {
			// Check each criteria
			for (let key in criteria) {
				//console.log (item.values()[key],criteria[key]);
			//	console.log (item.values());

				if (criteria[key] && criteria[key] !== "all" && item.values()[key] !== criteria[key]) {
					return false; // item doesn't match one of the criteria
				}
			}
			return true; // item matches all the criteria
		});
	}
	
	
	const shapeselect = document.querySelector('#shapeselect');
	if (shapeselect) {
		shapeselect.addEventListener('change', e => filterNew(e, evList));
	}
	
	const driveselect = document.querySelector('#driveselect');
	if (driveselect) {
		driveselect.addEventListener('change', e => filterNew(e, evList));
	}
	
	const seatselect = document.querySelector('#seatselect');
	if (seatselect) {
		seatselect.addEventListener('change', e => filterNew(e, evList));
	}
}

function applyRebate(status,list) {
	
	// See https://listjs.com/docs/item-api/
	for (const element of list.items) {
		 // console.log(element);
		  var price = element.values()['price'];
		  var amount = price.match(/\$[\s\S]*$/);
		  
		  var amountFormat = element.elm.dataset.price;
		  
		  if (status) { //Apply rebate
			  if (amountFormat != element.elm.dataset.rebate) {
				  amountFormat = element.elm.dataset.rebate;
				  addClass(element.elm, "rebated");
			  } 
		  }  else {
			  removeClass(element.elm, "rebated");
		  }
		  
		  price = price.replace( /\$[\s\S]*$/,amountFormat);
		  
		  element.values({price: price});	
	  }	
}

/**** Graph functions ****/
// From https://github.com/date-fns/date-fns

function toDate(argument) {
	var argStr = Object.prototype.toString.call(argument);
	// Clone the date
	if (argument instanceof Date ||
		(typeof argument === 'object' && argStr === '[object Date]')) {
		return new argument.constructor(argument.getTime());
	}
	else if (typeof argument === 'number' || argStr === '[object Number]') {
		return new Date(argument);
	}
	else {
		return new Date(NaN);
	}
}

function isSameYear(dirtyDateLeft, dirtyDateRight) {
	var dateLeft = toDate(dirtyDateLeft);
	var dateRight = toDate(dirtyDateRight);
	return dateLeft.getFullYear() === dateRight.getFullYear();
}

function isThisYear(dirtyDate) {
	return isSameYear(dirtyDate, Date.now());
}

function startOfQuarter(dirtyDate) {
	var date = toDate(dirtyDate);
	var currentMonth = date.getMonth();
	var month = currentMonth - (currentMonth % 3);
	date.setMonth(month, 1);
	date.setHours(0, 0, 0, 0);
	return date;
}

function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
	var dateLeftStartOfQuarter = startOfQuarter(dirtyDateLeft);
	var dateRightStartOfQuarter = startOfQuarter(dirtyDateRight);
	return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}

// Clickable rows on table
(function () {
	var elements = document.getElementsByTagName('tr');
	for (var i = 0; i < elements.length; i++) {
	    var element = elements[i];
	    
	    if (element.dataset.href) {
		    element.addEventListener('click', function() {
		        var href = this.dataset.href;
		        if (href) {
		            window.location.assign(href);
		        }
		    });
	    }
	}
})();

/*
 * Drop v11.5.0: Simple, mobile-friendly dropdown menus
 * (c) 2016 Chris Ferdinandi
 * MIT License
 * http://github.com/cferdinandi/drop
 */

(function (root, factory) {
	if ( typeof define === 'function' && define.amd ) {
		define([], factory(root));
	} else if ( typeof exports === 'object' ) {
		module.exports = factory(root);
	} else {
		root.drop = factory(root);
	}
})(typeof global !== 'undefined' ? global : this.window || this.global, (function (root) {

	'use strict';

	var drop = {}; // Object for public APIs
	var supports = 'querySelector' in document && 'addEventListener' in root && 'classList' in document.createElement('_'); // Feature test
	//var isTouch = 'ontouchstart' in document; // Check for touch support
	var settings;

	// Default settings
	var defaults = {
		selector: '.dropdown',
		activeClass: 'active',
		initClass: 'js-drop',
		callback: function () {}
	};
	//
	// Methods
	//

	/**
	 * A simple forEach() implementation for Arrays, Objects and NodeLists
	 */
	var forEach = function (collection, callback, scope) {
		if (Object.prototype.toString.call(collection) === '[object Object]') {
			for (var prop in collection) {
				if (Object.prototype.hasOwnProperty.call(collection, prop)) {
					callback.call(scope, collection[prop], prop, collection);
				}
			}
		} else {
			for (var i = 0, len = collection.length; i < len; i++) {
				callback.call(scope, collection[i], i, collection);
			}
		}
	};

	/**
	 * Merge defaults with user options
	 * @private
	 * @param {Object} defaults Default settings
	 * @param {Object} options User options
	 * @returns {Object} Merged values of defaults and options
	 */
	var extend = function () {

		// Variables
		var extended = {};
		var deep = false;
		var i = 0;
		var length = arguments.length;

		// Check if a deep merge
		if ( Object.prototype.toString.call( arguments[0] ) === '[object Boolean]' ) {
			deep = arguments[0];
			i++;
		}

		// Merge the object into the extended object
		var merge = function (obj) {
			for ( var prop in obj ) {
				if ( Object.prototype.hasOwnProperty.call( obj, prop ) ) {
					// If deep merge and property is an object, merge properties
					if ( deep && Object.prototype.toString.call(obj[prop]) === '[object Object]' ) {
						extended[prop] = buoy.extend( true, extended[prop], obj[prop] );
					} else {
						extended[prop] = obj[prop];
					}
				}
			}
		};

		// Loop through each object and conduct a merge
		for ( ; i < length; i++ ) {
			var obj = arguments[i];
			merge(obj);
		}

		return extended;

	};

	/**
	 * Get the closest matching element up the DOM tree.
	 */
	var getClosest = function ( elem, selector ) {

		// Element.matches() polyfill
		if (!Element.prototype.matches) {
			Element.prototype.matches =
				Element.prototype.matchesSelector ||
				Element.prototype.mozMatchesSelector ||
				Element.prototype.msMatchesSelector ||
				Element.prototype.oMatchesSelector ||
				Element.prototype.webkitMatchesSelector ||
				function(s) {
					var matches = (this.document || this.ownerDocument).querySelectorAll(s),
						i = matches.length;
					while (--i >= 0 && matches.item(i) !== this) {}
					return i > -1;
				};
		}

		// Get closest match
		for ( ; elem && elem !== document; elem = elem.parentNode ) {
			if ( elem.matches( selector ) ) return elem;
		}

		return null;
	};

	/**
	 * Close all dropdown menus
	 */
	drop.closeDrops = function () {

		// Get dropdowns
		var drops = document.querySelectorAll( settings.selector );

		// Close all the dropdowns
		forEach(drops, (function (drop) {
			drop.classList.remove( settings.activeClass );
		}));
	};

	/**
	 * Open a dropdown menu
	 */
	drop.openDrop = function ( toggle, options ) {

		// Selectors and variables
		var settings = extend( settings || defaults, options || {} );  // Merge user options with defaults

		// Close any open dropdown menus
		drop.closeDrops();

		// Open the toggled dropdown menu
		toggle.classList.add( settings.activeClass );

		// Run callbacks after drop toggle
		settings.callback( toggle );

	};

	/**
	 * Handle toggle and document click events
	 * @param {Event} event
	 * @private
	 */
	var clickHandler = function (event) {

		// Variables
		var toggle = event.target;
		var menu = getClosest( toggle, settings.selector );

		if ( menu ) {		
			// If dropdown menu, do nothing
			if ( menu.classList.contains( settings.activeClass ) ) {
				drop.closeDrops(); }
			else {
				drop.openDrop(menu, settings);
				event.preventDefault();
			}
			return;
		} else {
			// If document body, close open dropdown menus
			drop.closeDrops();
		}
	};

	/**
	 * Initialize Drop
	 */
	drop.init = function ( options ) {
		// feature test
		if ( !supports ) return;

		// Selectors and variables
		settings = extend( defaults, options || {} ); // Merge user options with defaults
		var toggles = document.querySelectorAll( settings.selector + ' > a' );
		document.addEventListener('click', clickHandler, false);
	};

	return drop;
}));

drop.init();



